import { Month } from '../view/admin/getEstimationMonths';
import ProductModel from './Product';

export default interface OrderDraft {
    month: Month;
    articlesOrdersDrafts: ArticleOrderDraft[];
}

export interface ItemValidationResult {
    sku: string;
    placed: number;
    corrected: number;
    type: 'c' | 's';
    reason: Reason;
}

export type Reason =
    | 'insufficientLevel'
    | 'itemNotEnabled'
    | 'liabilityNotMet'
    | 'packageSizeError'
    | 'exceedsAvailableInCheckout'
    | 'wrongOrderValues'
    | 'notEstimated';

export interface ArticleOrderDraft {
    articleId: string;
    wholesalePrice: number;
    discountCodeASet: boolean;
    itemsOrdersDrafts: ItemOrderDraft[];
}

export interface OrderStocks {
    toOrderFromEstimation: number;
    toOrderFromStock: number;
}

export interface ItemOrderDraft extends OrderStocks {
    sku: string;
    variantCode: string;
}

export interface OrderedSku {
    [sku: string]: number;
}

export interface SumValues {
    total: number;
    quantity: number;
}

const empty: [] = [];

export const getOrder = (articlesOrdersDrafts: ArticleOrderDraft[], article: ProductModel): ItemOrderDraft[] => {
    const articleOrderDraft = articlesOrdersDrafts.find((a: ArticleOrderDraft) => a.articleId === article.articleId);
    return articleOrderDraft ? articleOrderDraft.itemsOrdersDrafts : empty;
};

export const getOrderValue = (itemsOrdersDrafts: ItemOrderDraft[], sku: string, field: keyof OrderStocks): number => {
    const itemOrder: ItemOrderDraft | undefined = itemsOrdersDrafts.find((a: ItemOrderDraft) => a.sku === sku);
    if (itemOrder) {
        return itemOrder[field];
    }
    return 0;
};

export const getOrderedValue = (sku: string, orderedSku: OrderedSku): number => {
    return orderedSku[sku] || 0;
};



// WEBPACK FOOTER //
// ./src/domain/Order.ts